<template>
  <div class="profile-page">
    <!-- 头部用户信息区 -->
    <div class="profile-header">
      <!-- 左侧头像 -->
      <div class="avatar-section">
        <img :src="userInfo.avatar" class="user-avatar" alt="avatar" />
      </div>

      <!-- 中间信息区 -->
      <div class="user-info">
        <!-- 用户名和IP -->
        <div class="user-name-row">
          <h2 class="user-name">{{ userInfo.nickname }}</h2>
          <span class="user-meta">IP {{ userInfo.ip }} · ID {{ userInfo.userId }}</span>
        </div>

        <!-- 数据统计 -->
        <div class="user-stats">
          <div class="stat-item">
            <span class="stat-num">{{ userInfo.following }}</span>
            <span class="stat-label">关注</span>
          </div>
          <div class="stat-item">
            <span class="stat-num">{{ userInfo.followers }}</span>
            <span class="stat-label">粉丝</span>
          </div>
          <div class="stat-item">
            <span class="stat-num">{{ userInfo.likes }}</span>
            <span class="stat-label">赞</span>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="action-btns">
          <button class="edit-btn" @click="editProfile">编辑资料</button>
          <button class="share-btn" @click="shareProfile">
            <i class="el-icon-share"></i>
          </button>
        </div>

        <!-- 个人简介 -->
        <div class="user-bio">
          <p class="bio-line">
            <span class="bio-icon">👧🏻</span>
            <span>{{ userInfo.bio }}</span>
          </p>
          <p class="bio-line">
            <span class="bio-icon">⏰</span>
            <span>平日 {{ userInfo.liveTime }} 连线陪你喝下午茶 ✨</span>
          </p>
          <p class="bio-line">
            <span class="bio-icon">😊</span>
            <span>想把所有温柔的琐碎，都讲给你听 ☕</span>
          </p>
          <p class="bio-line">
            <span class="bio-icon">↓</span>
            <span>更多我的生活日常，都在下方链接里啦 ↓</span>
          </p>
        </div>
      </div>

      <!-- 右侧操作区 -->
      <div class="header-actions">
        <button class="upload-btn" @click="uploadContent">
          <i class="el-icon-upload2"></i>
          <span>上传</span>
        </button>
      </div>
    </div>

    <!-- 导航标签页 -->
    <div class="profile-tabs">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="tab-item"
        :class="{ active: activeTab === index }"
        @click="switchTab(index)"
      >
        {{ tab.name }}
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="profile-content">
      <!-- 观看历史 -->
      <div v-if="activeTab === 0" class="history-section">
        <div v-if="historyList.length > 0" class="video-grid">
          <div v-for="(item, index) in historyList" :key="index" class="video-card" @click="playVideo(item)">
            <div class="video-cover" :style="{ background: item.cover }">
              <span class="video-tag" :class="item.tagType">{{ item.tag }}</span>
              <span class="video-viewers">
                <i class="el-icon-user"></i>{{ item.viewers }}
              </span>
            </div>
            <div class="video-info">
              <img :src="item.avatar" class="video-avatar" alt="avatar" />
              <span class="video-name">{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <i class="el-icon-video-play"></i>
          <p>暂无观看记录</p>
        </div>
      </div>

      <!-- 收藏 -->
      <div v-else-if="activeTab === 1" class="favorite-section">
        <div v-if="favoriteList.length > 0" class="video-grid">
          <div v-for="(item, index) in favoriteList" :key="index" class="video-card" @click="playVideo(item)">
            <div class="video-cover" :style="{ background: item.cover }">
              <span class="video-tag" :class="item.tagType">{{ item.tag }}</span>
              <span class="video-viewers">
                <i class="el-icon-user"></i>{{ item.viewers }}
              </span>
            </div>
            <div class="video-info">
              <img :src="item.avatar" class="video-avatar" alt="avatar" />
              <span class="video-name">{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <i class="el-icon-star-off"></i>
          <p>暂无收藏内容</p>
        </div>
      </div>

      <!-- 赞过 -->
      <div v-else-if="activeTab === 2" class="liked-section">
        <div v-if="likedList.length > 0" class="video-grid">
          <div v-for="(item, index) in likedList" :key="index" class="video-card" @click="playVideo(item)">
            <div class="video-cover" :style="{ background: item.cover }">
              <span class="video-tag" :class="item.tagType">{{ item.tag }}</span>
              <span class="video-viewers">
                <i class="el-icon-user"></i>{{ item.viewers }}
              </span>
            </div>
            <div class="video-info">
              <img :src="item.avatar" class="video-avatar" alt="avatar" />
              <span class="video-name">{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <i class="el-icon-thumb"></i>
          <p>暂无赞过的内容</p>
        </div>
      </div>

      <!-- 钱包 -->
      <div v-else-if="activeTab === 3" class="wallet-section">
        <div class="wallet-card">
          <div class="wallet-user">
            <img :src="userInfo.avatar" class="wallet-avatar" alt="avatar" />
            <div class="wallet-user-info">
              <span class="wallet-email">1111@163.com</span>
              <span class="wallet-nickname">{{ userInfo.nickname }}</span>
            </div>
          </div>
          <div class="wallet-balance">
            <span class="balance-label">余额</span>
            <span class="balance-num">200</span>
            <span class="balance-unit">甜筒</span>
            <button class="recharge-btn" @click="recharge">充值</button>
          </div>
        </div>
        <div class="wallet-records">
          <h4 class="records-title">消费记录</h4>
          <div v-if="consumeRecords.length > 0" class="records-list">
            <div v-for="(record, index) in consumeRecords" :key="index" class="record-item">
              <span class="record-name">{{ record.name }}</span>
              <span class="record-amount" :class="{ income: record.type === 'income' }">{{ record.amount }}</span>
            </div>
          </div>
          <div v-else class="records-empty">暂无记录</div>
        </div>
      </div>

      <!-- 礼物 -->
      <div v-else-if="activeTab === 4" class="gift-section">
        <div v-if="giftRecords.length > 0" class="gift-list">
          <div v-for="(gift, index) in giftRecords" :key="index" class="gift-item">
            <div class="gift-icon">
              <img :src="gift.icon" alt="gift" />
            </div>
            <span class="gift-count">x{{ gift.count }}</span>
          </div>
        </div>
        <div v-else class="empty-state">
          <i class="el-icon-present"></i>
          <p>暂无礼物记录</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfilePage',
  data() {
    return {
      // 用户信息
      userInfo: {
        nickname: '魔法少女慈禧',
        avatar: 'https://via.placeholder.com/120',
        ip: '北京',
        userId: '123456789',
        following: 1,
        followers: 0,
        likes: 0,
        bio: '这里有捕捉生活小确幸的可爱日常 🌻',
        liveTime: '13:00~15:00'
      },
      // 标签页
      tabs: [
        { name: '观看历史', id: 'history' },
        { name: '收藏', id: 'favorite' },
        { name: '赞过', id: 'liked' },
        { name: '钱包', id: 'wallet' },
        { name: '礼物', id: 'gift' }
      ],
      // 当前选中标签
      activeTab: 0,
      // 观看历史 - 使用背景渐变色代替图片
      historyList: [
        { id: 1, name: '甜甜音悦台', cover: 'linear-gradient(135deg, #8B5CF6 0%, #A855F7 100%)', avatar: 'https://via.placeholder.com/30', tag: '直播', tagType: 'live', viewers: '12345' },
        { id: 2, name: '甜甜音悦台', cover: 'linear-gradient(135deg, #FF6B9D 0%, #FF8FB0 100%)', avatar: 'https://via.placeholder.com/30', tag: '回放', tagType: 'replay', viewers: '233' },
        { id: 3, name: '甜甜音悦台', cover: 'linear-gradient(135deg, #4ECDC4 0%, #7EDDD7 100%)', avatar: 'https://via.placeholder.com/30', tag: '直播', tagType: 'live', viewers: '233' }
      ],
      // 收藏列表
      favoriteList: [],
      // 赞过列表
      likedList: [],
      // 消费记录
      consumeRecords: [],
      // 送礼记录
      giftRecords: [
        { icon: require('../../assets/zhibo_hui.png'), count: 1 },
        { icon: require('../../assets/zhibo_hui.png'), count: 1 }
      ]
    }
  },
  methods: {
    // 编辑资料
    editProfile() {
      this.$emit('editProfile')
    },
    // 分享主页
    shareProfile() {
      this.$emit('shareProfile')
    },
    // 上传内容
    uploadContent() {
      this.$router.push('/scsp');
    },
    // 显示菜单
    showMenu() {
      this.$emit('showMenu')
    },
    // 切换标签
    switchTab(index) {
      this.activeTab = index
    },
    // 播放视频
    playVideo() {
      this.$router.push('/zb');
    },
    // 充值 - 打开充值弹窗
    recharge() {
      this.$store.commit('setVipshow', true)
    }
  }
}
</script>

<style scoped lang="scss">
// 页面主容器
.profile-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #ffffff 0%, hsl(0, 0%, 100%) 100%);
  padding: 40px 48px;
}

// 头部用户信息区
.profile-header {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  margin-bottom: 32px;
}

// 头像区域
.avatar-section {
  flex-shrink: 0;
}

.user-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

// 用户信息区
.user-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

// 用户名行
.user-name-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-name {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.user-meta {
  font-size: 13px;
  color: #999;
}

// 数据统计
.user-stats {
  display: flex;
  gap: 24px;
}

.stat-item {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.stat-num {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.stat-label {
  font-size: 14px;
  color: #666;
}

// 操作按钮
.action-btns {
  display: flex;
  gap: 12px;
}

.edit-btn {
  padding: 8px 20px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  font-size: 13px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}

.share-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}

// 个人简介
.user-bio {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.bio-line {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}

.bio-icon {
  font-size: 14px;
}

// 头部右侧操作
.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.upload-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 20px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  font-size: 13px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  i {
    font-size: 14px;
  }
}

.menu-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  cursor: pointer;
  color: #999;
  font-size: 18px;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.9);
    color: #666;
  }
}

// 导航标签页
.profile-tabs {
  display: flex;
  gap: 48px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  margin-bottom: 24px;
}

.tab-item {
  font-size: 15px;
  color: #666;
  cursor: pointer;
  padding: 8px 0;
  position: relative;
  transition: all 0.3s ease;

  &:hover {
    color: #8a3ffc;
  }

  &.active {
    color: #8a3ffc;
    font-weight: 500;

    &::after {
      content: '';
      position: absolute;
      bottom: -12px;
      left: 50%;
      transform: translateX(-50%);
      width: 20px;
      height: 2px;
      background: #8a3ffc;
      border-radius: 1px;
    }
  }
}

// 内容区域
.profile-content {
  background: rgba(255, 255, 255, 0.6);
  border-radius: 16px;
  padding: 24px;
  min-height: 400px;
}

// 空内容
.empty-content {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  color: #999;
  font-size: 14px;
}

// 视频网格
.video-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}

.video-card {
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-4px);
  }
}

.video-cover {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 10;
  background-size: cover;
  background-position: center;
  border-radius: 12px;
  overflow: hidden;
}

.video-tag {
  position: absolute;
  top: 8px;
  left: 8px;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  color: #fff;

  &.live {
    background: #FF6B9D;
  }

  &.replay {
    background: #9B8DC7;
  }
}

.video-viewers {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #fff;
  background: rgba(0, 0, 0, 0.4);
  padding: 2px 8px;
  border-radius: 12px;
}

.video-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}

.video-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.video-name {
  font-size: 13px;
  color: #333;
}

// 空状态
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  color: #999;

  i {
    font-size: 48px;
    margin-bottom: 16px;
    color: #ccc;
  }

  p {
    font-size: 14px;
  }
}

// 钱包区域
.wallet-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.wallet-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 12px;
}

.wallet-user {
  display: flex;
  align-items: center;
  gap: 12px;
}

.wallet-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}

.wallet-user-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.wallet-email {
  font-size: 14px;
  color: #333;
}

.wallet-nickname {
  font-size: 12px;
  color: #999;
}

.wallet-balance {
  display: flex;
  align-items: center;
  gap: 8px;
}

.balance-label {
  font-size: 14px;
  color: #666;
}

.balance-num {
  font-size: 20px;
  font-weight: 600;
  color: #8B5CF6;
}

.balance-unit {
  font-size: 14px;
  color: #666;
}

.wallet-balance .recharge-btn {
  margin-left: 12px;
  padding: 8px 20px;
  background: linear-gradient(135deg, #8B5CF6 0%, #A855F7 100%);
  border: none;
  border-radius: 20px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.9;
  }
}

.wallet-records {
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 12px;
}

.records-title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin: 0 0 16px 0;
}

.records-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.record-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);

  &:last-child {
    border-bottom: none;
  }
}

.record-name {
  font-size: 14px;
  color: #333;
}

.record-amount {
  font-size: 14px;
  color: #FF6B9D;
  font-weight: 500;

  &.income {
    color: #52C41A;
  }
}

.records-empty {
  padding: 40px 0;
  text-align: center;
  font-size: 14px;
  color: #999;
}

// 礼物区域
.gift-section {
  .gift-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .gift-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 12px;
    transition: all 0.3s ease;

    &:hover {
      background: #fff;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    }
  }

  .gift-icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(138, 63, 252, 0.1);
    border-radius: 8px;

    img {
      width: 32px;
      height: 32px;
      object-fit: contain;
    }
  }

  .gift-count {
    font-size: 14px;
    color: #666;
  }
}
</style>